import { Box, Typography } from "@mui/material";
import { useState } from "react";
import { CustomModal } from "../../../common/components/Modal";

const imageOptions = [
  {
    imageSrc: "/assests/20250612002157A.jpg",
    label: "Original Image",
  },
  {
    imageSrc: "/assests/20250612002157B.jpg",
    label: "Inspected Image",
  },
];

export const InspectedImage = () => {
  const [openModal, setOpenModal] = useState(false);
  const [selectedImage, setSelectedImage] = useState("");

  const openImageViewer = (imageUrl: string) => {
    setSelectedImage(imageUrl);
    setOpenModal(true);
  };

  const closeImageViewer = () => {
    setOpenModal(false);
    setSelectedImage("");
  };

  return (
    <Box>
      <Typography sx={{ color: "#003366" }} variant="h6" mb={2}>
        Defect Images
      </Typography>

      <Box display="flex" gap={4}>
        {imageOptions.map(({ imageSrc, label }) => (
          <Box key={label} textAlign="center">
            <Typography
              sx={{ color: "#003366" }}
              variant="subtitle2"
              gutterBottom
            >
              {label}
            </Typography>

            <Box
              component="img"
              src={imageSrc}
              alt={label}
              onClick={() => openImageViewer(imageSrc)}
              sx={{
                width: 100,
                height: 100,
                objectFit: "cover",
                border: "1px solid #003366",
                cursor: "pointer",
              }}
            />
          </Box>
        ))}
      </Box>

      <CustomModal open={openModal} onClose={closeImageViewer}>
        <Box
          component="img"
          src={selectedImage}
          alt="Inspected Images"
          sx={{
            width: "30%",
            height: "30%",
            objectFit: "contain",
          }}
        />
      </CustomModal>
    </Box>
  );
};
